export default function Hero() {
  return (
    <section id="top" className="mx-auto w-full max-w-7xl px-4 md:px-6 pt-36 md:pt-40 pb-6">
      {/* eyebrow / label */}
      <div className="flex items-center gap-3 mb-5">
        <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
          <span className="relative flex h-1.5 w-1.5">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-background-50 opacity-75"></span>
            <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-background-50"></span>
          </span>
          现场直击
        </span>
        <span className="text-xs text-foreground-500 hidden sm:inline">全网热点实时跟踪 · 吃瓜不迷路</span>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-5">
        {/* main headline */}
        <a
          href="#live"
          className="group relative block overflow-hidden rounded-2xl bg-foreground-950 lg:col-span-7"
        >
          <img
            src="https://readdy.ai/api/search-image?query=Grand%20television%20studio%20finale%20stage%20bathed%20in%20warm%20golden%20and%20coral%20spotlights%2C%20dramatic%20light%20beams%2C%20celebration%20confetti%20in%20air%2C%20cinematic%20editorial%20composition%2C%20rich%20warm%20color%20palette%2C%20high%20energy%20entertainment%20award%20atmosphere&width=1200&height=760&seq=hero-headline&orientation=landscape"
            alt="综艺决赛现场灯光璀璨的舞台氛围图"
            className="h-[320px] md:h-[440px] w-full object-cover object-top opacity-90 transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
          <div className="absolute inset-x-0 bottom-0 p-5 md:p-7">
            <div className="flex flex-wrap items-center gap-2 mb-3">
              <span className="whitespace-nowrap rounded-full bg-accent-400 px-2.5 py-1 text-[11px] font-medium text-foreground-950">
                今日焦点
              </span>
              <span className="whitespace-nowrap rounded-full bg-background-50/15 px-2.5 py-1 text-[11px] text-background-100 backdrop-blur-sm">
                综艺 · 决赛夜
              </span>
            </div>
            <h1 className="font-heading text-2xl md:text-4xl font-bold leading-snug text-background-50">
              决赛夜名场面刷屏全网，谁是你心中的年度意难平？
            </h1>
            <p className="mt-3 hidden md:block max-w-xl text-sm leading-relaxed text-background-200/90">
              今晚话题热度持续攀升，现场直击团队从灯光、舞台到选手瞬间，为你还原每一个值得围观的细节。
            </p>
            <div className="mt-4 flex items-center gap-4 text-xs text-background-300">
              <span className="inline-flex items-center gap-1.5">
                <i className="ri-time-line"></i> 更新于 10 分钟前
              </span>
              <span className="inline-flex items-center gap-1.5">
                <i className="ri-eye-line"></i> 218 万围观
              </span>
              <span className="inline-flex items-center gap-1 whitespace-nowrap text-accent-300 group-hover:gap-2 transition-all">
                进入现场 <i className="ri-arrow-right-line"></i>
              </span>
            </div>
          </div>
        </a>

        {/* side stack */}
        <div className="lg:col-span-5 grid grid-rows-2 gap-5">
          <a
            href="#digest"
            className="group relative block overflow-hidden rounded-2xl bg-secondary-500 text-background-50"
          >
            <div className="absolute inset-0 opacity-25">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20electric%20car%20silhouette%20driving%20through%20a%20city%20at%20night%20with%20warm%20street%20lights%2C%20minimalist%20automotive%20lifestyle%2C%20clean%20warm%20tones%2C%20editorial%20photography&width=640&height=360&seq=hero-side-1&orientation=landscape"
                alt="城市夜景中行驶的新能源汽车剪影"
                className="h-full w-full object-cover"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
            <div className="relative z-10 flex h-full min-h-[150px] flex-col justify-end p-5">
              <span className="mb-2 inline-flex w-fit whitespace-nowrap rounded-md bg-background-50/20 px-2 py-0.5 text-[11px] text-background-50 backdrop-blur-sm">
                科技风向
              </span>
              <h2 className="font-heading text-xl font-bold leading-snug">
                城市领航实测：智驾正告别「纸面参数」
              </h2>
            </div>
          </a>

          <a
            href="#columns"
            className="group relative block overflow-hidden rounded-2xl bg-foreground-950"
          >
            <div className="absolute inset-0 opacity-25">
              <img
                src="https://readdy.ai/api/search-image?query=People%20relaxing%20in%20a%20sunlit%20urban%20park%20at%20golden%20hour%2C%20picnic%20blankets%20and%20chatter%2C%20relaxed%20city%20lifestyle%2C%20warm%20cinematic%20lighting%2C%20editorial%20reportage&width=640&height=360&seq=hero-side-2&orientation=landscape"
                alt="傍晚公园里市民休闲放松的画面"
                className="h-full w-full object-cover"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
            <div className="relative z-10 flex h-full min-h-[150px] flex-col justify-end p-5">
              <span className="mb-2 inline-flex w-fit whitespace-nowrap rounded-md bg-accent-400 px-2 py-0.5 text-[11px] text-foreground-950">
                社会百态
              </span>
              <h2 className="font-heading text-xl font-bold leading-snug text-background-50">
                高温之下的城市，松弛感从何而来？
              </h2>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}